import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery-ui/dist/jquery-ui.min';
import '../../../src/js/valida-campos.js';


const valida_forms = function (form_obj) {
    /*
    Passou a ser enviado por AJAX
    if ($(form_obj).attr('name') == 'plano_personalizado') {
        // iniciacoes
        var campos_form = new Array('nome_informacoes', 'contacto_informacoes');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function(index, campo) {
                campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
                campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
            })
            // end iniciacoes
        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function() { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!is_Telefone(campos_obj[1].val()) || campos_obj[1].val().trim().length < 8) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function() { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        return true;
    }
    */
    if ($(form_obj).attr('name') == 'regista_empresa') {
        // iniciacoes
        //var campos_form = new Array('pacote_comercial', 'nome_empresa', 'contribuinte', 'morada', 'codigo_postal', 'localidade', 'certidao_permanente', 'url', 'nome_administrador', 'email', 'contacto', 'username', 'password', 'pacote_comercial_popover', 'password_conf', 'metodo_pagamento', 'opcao_pagamento', 'inicio_atividade', 'pacote_duracao0');
        var campos_form = new Array('pacote_comercial', 'nome_empresa', 'contribuinte', 'morada', 'codigo_postal', 'localidade', 'certidao_permanente', 'url', 'nome_administrador', 'email', 'contacto', 'username', 'password', 'pacote_comercial_popover', 'password_conf', 'metodo_pagamento', 'opcao_pagamento', 'pacote_duracao0');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if (campos_obj[0].val() == '') {
            //campos_obj[13].trigger('focus');
            $("html, body").animate({ scrollTop: 0 }, "slow")
            campos_popovers[13].show();
            $('.card-pacotes').on('click', function () { campos_popovers[13].hide(); })
            return false;
        } else {
            campos_popovers[13].hide();
        }
        if (campos_obj[17].val() == '') {
            //campos_obj[13].trigger('focus');
            $("html, body").animate({ scrollTop: 0 }, "slow")
            campos_popovers[13].show();
            campos_obj[17].on('click', function () { campos_popovers[13].hide(); })
            return false;
        } else {
            campos_popovers[13].hide();
        }
        if (!is_Nome(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
            campos_obj[1].trigger('focus');
            campos_popovers[1].show();
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!campos_obj[2].is_Valid()) {
            campos_popovers[2].show();
            campos_obj[2].trigger('focus');
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }

        if (!is_Morada(campos_obj[3].val()) || campos_obj[3].val().trim().length < 5) {
            campos_popovers[3].show();
            campos_obj[3].trigger('focus');
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }
        if (!is_Cp(campos_obj[4].val()) || campos_obj[4].val().trim().length < 4) {
            campos_popovers[4].show();
            campos_obj[4].trigger('focus');
            campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
            return false;
        } else {
            campos_popovers[4].hide();
        }
        if (!is_Localidade(campos_obj[5].val()) || campos_obj[5].val().trim().length < 3) {
            campos_popovers[5].show();
            campos_obj[5].trigger('focus');
            campos_obj[5].on('keypress', function () { campos_popovers[5].hide(); })
            return false;
        } else {
            campos_popovers[5].hide();
        }
        /*
        if (campos_obj[6].val().trim().length == 0 && campos_obj[17][0].files.length < 1) {
            campos_popovers[6].show();
            campos_obj[6].trigger('focus');
            campos_obj[6].on('keypress', function() { campos_popovers[6].hide(); })
            return false;
        } else {
            campos_popovers[6].hide();
        }
        */
        if (campos_obj[6].val().trim().length > 0 && campos_obj[6].val().trim().length < 10) {
            campos_popovers[6].show();
            campos_obj[6].trigger('focus');
            campos_obj[6].on('keypress', function () { campos_popovers[6].hide(); })
            return false;
        } else {
            campos_popovers[6].hide();
        }
        if (campos_obj[7].val().trim().length > 0) {
            if (!is_Url(campos_obj[7].val())) {
                campos_popovers[7].show();
                campos_obj[7].trigger('focus');
                campos_obj[7].on('keypress', function () { campos_popovers[7].hide(); })
                return false;
            } else {
                campos_popovers[7].hide();
            }
        }
        if (!is_Nome(campos_obj[8].val()) || campos_obj[8].val().trim().length < 5) {
            campos_popovers[8].show();
            campos_obj[8].trigger('focus');
            campos_obj[8].on('keypress', function () { campos_popovers[8].hide(); })
            return false;
        } else {
            campos_popovers[8].hide();
        }
        if (!is_Email(campos_obj[9].val()) || campos_obj[9].val().trim().length < 5) {
            campos_popovers[9].show();
            campos_obj[9].trigger('focus');
            campos_obj[9].on('keypress', function () { campos_popovers[9].hide(); })
            return false;
        } else {
            campos_popovers[9].hide();
        }
        if (!is_Telefone(campos_obj[10].val()) || campos_obj[10].val().trim().length < 8) {
            campos_popovers[10].show();
            campos_obj[10].trigger('focus');
            campos_obj[10].on('keypress', function () { campos_popovers[10].hide(); })
            return false;
        } else {
            campos_popovers[10].hide();
        }
        if (!is_Utilizador(campos_obj[11].val()) || campos_obj[11].val().trim().length < 8) {
            campos_popovers[11].show();
            campos_obj[11].trigger('focus');
            campos_obj[11].on('keypress', function () { campos_popovers[11].hide(); })
            return false;
        } else {
            campos_popovers[11].hide();
        }
        if (!is_Password(campos_obj[12].val()) || campos_obj[12].val().trim().length < 8) {
            campos_popovers[12].show();
            campos_obj[12].trigger('focus');
            campos_obj[12].on('keypress', function () { campos_popovers[12].hide(); })
            return false;
        } else {
            campos_popovers[12].hide();
        }

        if ((campos_obj[12].val().trim().length > 0 || campos_obj[14].val().trim().length > 0) && (campos_obj[12].val() != campos_obj[14].val())) {
            campos_popovers[14].show();
            campos_obj[14].trigger('focus');
            campos_obj[14].on('keypress', function () { campos_popovers[14].hide(); })
            return false;
        } else {
            campos_popovers[14].hide();
        }

        if (campos_obj[15].val().trim().length == 0) {
            campos_popovers[16].show();
            campos_obj[16].trigger('focus');
            campos_obj[16].on('keypress', function () { campos_popovers[16].hide(); })
            return false;
        } else {
            campos_popovers[16].hide();
        }

        //$(form_obj).trigger('submit');

        return true;
    }
    if ($(form_obj).attr('name') == 'edita_empresa') {
        // iniciacoes
        var campos_form = new Array('nome_empresa', 'contribuinte', 'morada', 'codigo_postal', 'localidade', 'certidao_permanente', 'url');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!campos_obj[1].is_Valid()) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!is_Morada(campos_obj[2].val()) || campos_obj[2].val().trim().length < 5) {
            campos_obj[2].trigger('focus');
            campos_popovers[2].show();
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }
        if (!is_Cp(campos_obj[3].val()) || campos_obj[3].val().trim().length < 4) {
            campos_obj[3].trigger('focus');
            campos_popovers[3].show();
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }
        if (!is_Localidade(campos_obj[4].val()) || campos_obj[4].val().trim().length < 3) {
            campos_obj[4].trigger('focus');
            campos_popovers[4].show();
            campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
            return false;
        } else {
            campos_popovers[4].hide();
        }
        /*
        if (campos_obj[5].val().trim().length < 14) {
            campos_obj[5].trigger('focus');
            campos_popovers[5].show();
            campos_obj[5].on('keypress', function() { campos_popovers[5].hide(); })
            return false;
        } else {
            campos_popovers[5].hide();
        }
            */
        if (!is_Url(campos_obj[6].val()) && campos_obj[6].val().trim().length > 0) {
            campos_obj[6].trigger('focus');
            campos_popovers[6].show();
            campos_obj[6].on('keypress', function () { campos_popovers[6].hide(); })
            return false;
        } else {
            campos_popovers[6].hide();
        }

        return true;
    }
    if ($(form_obj).attr('name') == 'edita_administrador') {
        // iniciacoes
        var campos_form = new Array('nome_administrador', 'email', 'contacto', 'username', 'password', 'password_conf');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!is_Email(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!is_Telefone(campos_obj[2].val()) || campos_obj[2].val().trim().length < 8) {
            campos_popovers[2].show();
            campos_obj[2].trigger('focus');
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }
        if (!is_Utilizador(campos_obj[3].val()) || campos_obj[3].val().trim().length < 8) {
            campos_popovers[3].show();
            campos_obj[3].trigger('focus');
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }
        if ((campos_obj[4].val().trim().length > 0 && campos_obj[4].val().trim().length < 8)) {
            if (!is_Password(campos_obj[4].val())) {
                campos_popovers[4].show();
                campos_obj[4].trigger('focus');
                campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
                return false;
            } else {
                return true;
            }
        } else {
            campos_popovers[4].hide();
        }
        if ((campos_obj[4].val().trim().length > 0 || campos_obj[5].val().trim().length > 0) && (campos_obj[4].val() != campos_obj[5].val())) {
            campos_popovers[5].show();
            campos_obj[5].trigger('focus');
            campos_obj[5].on('keypress', function () { campos_popovers[5].hide(); })
            return false;
        } else {
            campos_popovers[5].hide();
        }
        return true;
    }

    if ($(form_obj).attr('name').substring(0, 15) == 'edita_sucursal_') {
        var indice_formulario = $(form_obj).attr('name').substring(15);
        // iniciacoes
        var campos_form = new Array('nome_sucursal', 'morada_sucursal', 'codigo_postal_sucursal', 'localidade_sucursal', 'url_sucursal');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!is_Morada(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
            campos_obj[1].trigger('focus');
            campos_popovers[1].show();
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!is_Cp(campos_obj[2].val()) || campos_obj[2].val().trim().length < 4) {
            campos_obj[2].trigger('focus');
            campos_popovers[2].show();
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }
        if (!is_Localidade(campos_obj[3].val()) || campos_obj[3].val().trim().length < 3) {
            campos_obj[3].trigger('focus');
            campos_popovers[3].show();
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }
        if (!is_Url(campos_obj[4].val()) && campos_obj[4].val().trim().length > 0) {
            campos_obj[4].trigger('focus');
            campos_popovers[4].show();
            campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
            return false;
        } else {
            campos_popovers[4].hide();
        }
        return true;
    }
    if ($(form_obj).attr('name') == 'setpsw') {
        // iniciacoes
        var campos_form = new Array('password', 'password_conf');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if ((campos_obj[0].val().trim().length < 8) || !is_Password(campos_obj[0].val())) {
            campos_popovers[0].show();
            campos_obj[0].trigger('focus');
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (campos_obj[0].val() != campos_obj[1].val()) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        return true;
    }
    if ($(form_obj).attr('name') == 'registo_utilizador') {
        // iniciacoes
        var campos_form = new Array('nome_utilizador', 'email', 'contacto', 'username', 'password', 'password_conf', 'nome_empresa');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes

        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!is_Email(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!is_Telefone(campos_obj[2].val()) || campos_obj[2].val().trim().length < 8) {
            campos_popovers[2].show();
            campos_obj[2].trigger('focus');
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }
        if (!is_Utilizador(campos_obj[3].val()) || campos_obj[3].val().trim().length < 8) {
            campos_popovers[3].show();
            campos_obj[3].trigger('focus');
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }

        if (!is_Password(campos_obj[4].val()) || campos_obj[4].val().trim().length < 8) {
            campos_popovers[4].show();
            campos_obj[4].trigger('focus');
            campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
            return false;
        } else {
            campos_popovers[4].hide();
        }

        if ((campos_obj[4].val().trim().length > 0 || campos_obj[5].val().trim().length > 0) && (campos_obj[4].val() != campos_obj[5].val())) {
            campos_popovers[5].show();
            campos_obj[5].trigger('focus');
            campos_obj[5].on('keypress', function () { campos_popovers[5].hide(); })
            return false;
        } else {
            campos_popovers[5].hide();
        }

        if (campos_obj[6].prop('selectedIndex') == 0) {
            campos_popovers[6].show();
            campos_obj[6].trigger('focus');
            campos_obj[6].change(function () { campos_popovers[6].hide(); })
            return false;
        } else {
            campos_popovers[6].hide();
        }
        return true;
    }
    if ($(form_obj).attr('name') == 'edit_utilizador') {
        // iniciacoes
        var campos_form = new Array('nome_utilizador', 'email', 'contacto', 'username', 'password', 'password_conf');
        var campos_obj = new Array();
        var campos_popovers = new Array();

        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes

        if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        if (!is_Email(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
            campos_popovers[1].show();
            campos_obj[1].trigger('focus');
            campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
            return false;
        } else {
            campos_popovers[1].hide();
        }
        if (!is_Telefone(campos_obj[2].val()) || campos_obj[2].val().trim().length < 8) {
            campos_popovers[2].show();
            campos_obj[2].trigger('focus');
            campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
            return false;
        } else {
            campos_popovers[2].hide();
        }
        if (!is_Utilizador(campos_obj[3].val()) || campos_obj[3].val().trim().length < 8) {
            campos_popovers[3].show();
            campos_obj[3].trigger('focus');
            campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
            return false;
        } else {
            campos_popovers[3].hide();
        }

        if (campos_obj[4].val().trim().length > 0) {
            if (!is_Password(campos_obj[4].val()) || campos_obj[4].val().trim().length < 8) {
                campos_popovers[4].show();
                campos_obj[4].trigger('focus');
                campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
                return false;
            } else {
                campos_popovers[4].hide();
            }
        }

        if ((campos_obj[4].val().trim().length > 0 || campos_obj[5].val().trim().length > 0) && (campos_obj[4].val() != campos_obj[5].val())) {
            campos_popovers[5].show();
            campos_obj[5].trigger('focus');
            campos_obj[5].on('keypress', function () { campos_popovers[5].hide(); })
            return false;
        } else {
            campos_popovers[5].hide();
        }
        return true;
    }
    if ($(form_obj).attr('name') == 'utilizador_core_business') {
        // iniciacoes
        var campos_form = new Array('tipo_localizacoes', 'endereco_recolha', 'endereco_entrega', 'transporte_paletes_volumes', 'envio_documentacao', 'transporte_especial', 'transporte_veiculos', 'mudancas', 'paletes', 'volumes', 'carga_temperatura', 'adr', 'ligeiros', 'pesados', 'motociclos', 'servicos_efetuados_popover', 'localizacoes_efetuadas_popover');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        if (campos_obj[3].is(':not(":checked")') && campos_obj[4].is(':not(":checked")') && campos_obj[5].is(':not(":checked")') && campos_obj[6].is(':not(":checked")') && campos_obj[7].is(':not(":checked")')) {
            campos_popovers[15].show();
            campos_obj[3].trigger('focus');
            campos_obj[3].change(function () { campos_popovers[15].hide(); })
            return false;
        } else {
            campos_popovers[15].hide();
        }
        if (campos_obj[3].is(':checked') && (campos_obj[8].is(':not(":checked")') && campos_obj[9].is(':not(":checked")') && campos_obj[10].is(':not(":checked")') && campos_obj[11].is(':not(":checked")'))) {
            campos_popovers[8].show();
            campos_obj[8].trigger('focus');
            campos_obj[8].add(campos_obj[9]).add(campos_obj[10]).add(campos_obj[11]).change(function () { campos_popovers[8].hide(); })
            return false;
        } else {
            campos_popovers[8].hide();
        }
        if (campos_obj[6].is(':checked') && (campos_obj[12].is(':not(":checked")') && campos_obj[13].is(':not(":checked")') && campos_obj[14].is(':not(":checked")'))) {
            campos_popovers[12].show();
            campos_obj[12].trigger('focus');
            campos_obj[12].add(campos_obj[13]).add(campos_obj[14]).change(function () { campos_popovers[12].hide(); })
            return false;
        } else {
            campos_popovers[12].hide();
        }

        // Para a escolha de localizações    
        if (campos_obj[0].filter('#todos').is(':not(":checked")') && campos_obj[0].filter('#portugal').is(':not(":checked")') && campos_obj[0].filter('#varias').is(':not(":checked")')) {
            campos_popovers[16].show();
            campos_obj[0].trigger('focus');
            campos_obj[0].change(function () { campos_popovers[16].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
            if (campos_obj[0].filter('#varias').is(':checked') && $('.enderecos-recolha').html().trim() == '') {
                campos_popovers[1].show();
                campos_obj[1].trigger('focus');
                campos_obj[1].change(function () { campos_popovers[1].hide(); })
                return false;
            } else {
                campos_popovers[1].hide();
            }
            if (campos_obj[0].filter('#varias').is(':checked') && $('.enderecos-entrega').html().trim() == '') {
                campos_popovers[2].show();
                campos_obj[2].trigger('focus');
                campos_obj[2].change(function () { campos_popovers[2].hide(); })
                return false;
            } else {
                campos_popovers[2].hide();
            }

        }
        return true;
    }
    if ($(form_obj).attr('name') == 'atribui_pacote') {
        // iniciacoes
        var campos_form = new Array('pacote_duracao');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes
        // Como o select está fora do form, tem de ser manualmente    
        var select_empresa_codigo = $('select[name="empresas_mae"]');
        var select_metodo_pagamento = $('select[name="metodo_pagamento"]');
        var input_referencia_multibanco = $('input[name="referencia_multibanco"]');
        var select_estado_pagamento = $('select[name="estado_pagamento"]');
        var select_estado_subscricao = $('select[name="estado_subscricao"]');

        var selectempresacodigo_popovers;
        var selectmetodopagamento_popovers;
        var inputreferenciamultibanco_popovers;
        var selectestadopagamento_popovers;
        var selectestadosubscricao_popovers;

        selectempresacodigo_popovers = new bootstrap.Popover(select_empresa_codigo);
        selectmetodopagamento_popovers = new bootstrap.Popover(select_metodo_pagamento);
        inputreferenciamultibanco_popovers = new bootstrap.Popover(input_referencia_multibanco);
        selectestadopagamento_popovers = new bootstrap.Popover(select_estado_pagamento);
        selectestadosubscricao_popovers = new bootstrap.Popover(select_estado_subscricao);


        if (select_empresa_codigo.prop('selectedIndex') == 0) {
            selectempresacodigo_popovers.show();
            select_empresa_codigo.trigger('focus');
            select_empresa_codigo.change(function () { selectempresacodigo_popovers.hide(); })
            return false;
        } else {
            selectempresacodigo_popovers.hide();
        }

        if (select_metodo_pagamento.prop('selectedIndex') == 0) {
            selectmetodopagamento_popovers.show();
            select_metodo_pagamento.trigger('focus');
            select_metodo_pagamento.change(function () { selectmetodopagamento_popovers.hide(); })
            return false;
        } else {
            selectmetodopagamento_popovers.hide();
        }

        if (input_referencia_multibanco.val().trim().length < 9) {
            inputreferenciamultibanco_popovers.show();
            input_referencia_multibanco.trigger('focus');
            input_referencia_multibanco.change(function () { inputreferenciamultibanco_popovers.hide(); })
            return false;
        } else {
            inputreferenciamultibanco_popovers.hide();
        }

        if (select_estado_pagamento.prop('selectedIndex') == 0) {
            selectestadopagamento_popovers.show();
            select_estado_pagamento.trigger('focus');
            select_estado_pagamento.change(function () { selectestadopagamento_popovers.hide(); })
            return false;
        } else {
            selectestadopagamento_popovers.hide();
        }

        if (select_estado_subscricao.prop('selectedIndex') == 0) {
            selectestadosubscricao_popovers.show();
            select_estado_subscricao.trigger('focus');
            select_estado_subscricao.change(function () { selectestadosubscricao_popovers.hide(); })
            return false;
        } else {
            selectestadosubscricao_popovers.hide();
        }

        if (campos_obj[0].prop('selectedIndex') == 0) {
            campos_popovers[0].show();
            campos_obj[0].trigger('focus');
            campos_obj[0].change(function () { campos_popovers[0].hide(); })
            return false;
        } else {
            campos_popovers[0].hide();
        }
        return true;
    }
    if ($(form_obj).attr('name') == 'novo_cliente') {
        // iniciacoes
        var campos_form = new Array('nome_cliente[0]', 'email[0]', 'contacto[0]', 'nome_cliente[1]', 'email[1]', 'contacto[1]', 'nome_cliente[2]', 'email[2]', 'contacto[2]', 'nome_cliente[3]', 'email[3]', 'contacto[3]', 'nome_cliente[4]', 'email[4]', 'contacto[4]');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })
        // end iniciacoes

        var existe_linhacliente = false;
        // CAMPOS DA LINHA 1
        if (campos_obj[0].val().trim().length > 0 || campos_obj[1].val().trim().length > 0 || campos_obj[2].val().trim().length > 0) {
            existe_linhacliente = true;
            if (!is_Nome(campos_obj[0].val()) || campos_obj[0].val().trim().length < 5) {
                campos_obj[0].trigger('focus');
                campos_popovers[0].show();
                campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
                return false;
            } else {
                campos_popovers[0].hide();
            }
            if (!is_Email(campos_obj[1].val()) || campos_obj[1].val().trim().length < 5) {
                campos_popovers[1].show();
                campos_obj[1].trigger('focus');
                campos_obj[1].on('keypress', function () { campos_popovers[1].hide(); })
                return false;
            } else {
                campos_popovers[1].hide();
            }
            if (!is_Telefone(campos_obj[2].val()) || campos_obj[2].val().trim().length < 8) {
                campos_popovers[2].show();
                campos_obj[2].trigger('focus');
                campos_obj[2].on('keypress', function () { campos_popovers[2].hide(); })
                return false;
            } else {
                campos_popovers[2].hide();
            }
        }
        // CAMPOS DA LINHA 2
        if (campos_obj[3].val().trim().length > 0 || campos_obj[4].val().trim().length > 0 || campos_obj[5].val().trim().length > 0) {
            existe_linhacliente = true;
            if (!is_Nome(campos_obj[3].val()) || campos_obj[3].val().trim().length < 5) {
                campos_obj[3].trigger('focus');
                campos_popovers[3].show();
                campos_obj[3].on('keypress', function () { campos_popovers[3].hide(); })
                return false;
            } else {
                campos_popovers[3].hide();
            }
            if (!is_Email(campos_obj[4].val()) || campos_obj[4].val().trim().length < 5) {
                campos_popovers[4].show();
                campos_obj[4].trigger('focus');
                campos_obj[4].on('keypress', function () { campos_popovers[4].hide(); })
                return false;
            } else {
                campos_popovers[4].hide();
            }
            if (!is_Telefone(campos_obj[5].val()) || campos_obj[5].val().trim().length < 8) {
                campos_popovers[5].show();
                campos_obj[5].trigger('focus');
                campos_obj[5].on('keypress', function () { campos_popovers[5].hide(); })
                return false;
            } else {
                campos_popovers[5].hide();
            }
        }
        // CAMPOS DA LINHA 3
        if (campos_obj[6].val().trim().length > 0 || campos_obj[7].val().trim().length > 0 || campos_obj[8].val().trim().length > 0) {
            existe_linhacliente = true;
            if (!is_Nome(campos_obj[6].val()) || campos_obj[6].val().trim().length < 5) {
                campos_obj[6].trigger('focus');
                campos_popovers[6].show();
                campos_obj[6].on('keypress', function () { campos_popovers[6].hide(); })
                return false;
            } else {
                campos_popovers[6].hide();
            }
            if (!is_Email(campos_obj[7].val()) || campos_obj[7].val().trim().length < 5) {
                campos_popovers[7].show();
                campos_obj[7].trigger('focus');
                campos_obj[7].on('keypress', function () { campos_popovers[7].hide(); })
                return false;
            } else {
                campos_popovers[7].hide();
            }
            if (!is_Telefone(campos_obj[8].val()) || campos_obj[8].val().trim().length < 8) {
                campos_popovers[8].show();
                campos_obj[8].trigger('focus');
                campos_obj[8].on('keypress', function () { campos_popovers[8].hide(); })
                return false;
            } else {
                campos_popovers[8].hide();
            }
        }
        // CAMPOS DA LINHA 4
        if (campos_obj[9].val().trim().length > 0 || campos_obj[10].val().trim().length > 0 || campos_obj[11].val().trim().length > 0) {
            existe_linhacliente = true;
            if (!is_Nome(campos_obj[9].val()) || campos_obj[9].val().trim().length < 5) {
                campos_obj[9].trigger('focus');
                campos_popovers[9].show();
                campos_obj[9].on('keypress', function () { campos_popovers[9].hide(); })
                return false;
            } else {
                campos_popovers[9].hide();
            }
            if (!is_Email(campos_obj[10].val()) || campos_obj[10].val().trim().length < 5) {
                campos_popovers[10].show();
                campos_obj[10].trigger('focus');
                campos_obj[10].on('keypress', function () { campos_popovers[10].hide(); })
                return false;
            } else {
                campos_popovers[10].hide();
            }
            if (!is_Telefone(campos_obj[11].val()) || campos_obj[11].val().trim().length < 8) {
                campos_popovers[11].show();
                campos_obj[11].trigger('focus');
                campos_obj[11].on('keypress', function () { campos_popovers[11].hide(); })
                return false;
            } else {
                campos_popovers[11].hide();
            }
        }
        // CAMPOS DA LINHA 5
        if (campos_obj[12].val().trim().length > 0 || campos_obj[13].val().trim().length > 0 || campos_obj[14].val().trim().length > 0) {
            existe_linhacliente = true;
            if (!is_Nome(campos_obj[12].val()) || campos_obj[12].val().trim().length < 5) {
                campos_obj[12].trigger('focus');
                campos_popovers[12].show();
                campos_obj[12].on('keypress', function () { campos_popovers[12].hide(); })
                return false;
            } else {
                campos_popovers[12].hide();
            }
            if (!is_Email(campos_obj[13].val()) || campos_obj[13].val().trim().length < 5) {
                campos_popovers[13].show();
                campos_obj[13].trigger('focus');
                campos_obj[13].on('keypress', function () { campos_popovers[13].hide(); })
                return false;
            } else {
                campos_popovers[13].hide();
            }
            if (!is_Telefone(campos_obj[14].val()) || campos_obj[14].val().trim().length < 8) {
                campos_popovers[14].show();
                campos_obj[14].trigger('focus');
                campos_obj[14].on('keypress', function () { campos_popovers[14].hide(); })
                return false;
            } else {
                campos_popovers[14].hide();
            }
        }
        // Verifica se nenhuma linha, (registo de cliente), foi preenchida
        if (existe_linhacliente == false) {
            campos_obj[0].trigger('focus');
            campos_popovers[0].show();
            campos_obj[0].on('keypress', function () { campos_popovers[0].hide(); })
            return false;
        }

        return true;
    }
    if ($(form_obj).attr('name') == 'nova_carga_volumes') {
        // iniciacoes
        /*
        Aqui neste caso as iniciações são feitas uma a auma
        var campos_form = new Array('nome_cliente[0]', 'email[0]', 'contacto[0]', 'nome_cliente[1]', 'email[1]', 'contacto[1]', 'nome_cliente[2]', 'email[2]', 'contacto[2]', 'nome_cliente[3]', 'email[3]', 'contacto[3]', 'nome_cliente[4]', 'email[4]', 'contacto[4]');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            console.log(campo);
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })*/
        // end iniciacoes


        let valida = true;

        var campos_popovers_clientes;
        campos_popovers_clientes = new bootstrap.Popover($('[name="clientes_codigos"]'));
        if (valida && ($('[name="clientes_codigos"]').val() == '')) {
            campos_popovers_clientes.show();
            $('[name="clientes_codigos"]').trigger('focus');
            $('[name="clientes_codigos"]').on('keypress', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('change', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('click', function () { campos_popovers_clientes.hide(); })
            valida = false;
            return false;
        }


        $(form_obj).find('[name^="quantidade"]').filter(':visible').each(function (index, ele) {
            index += 1;
            var campos_popovers_quantidade = new Array();
            campos_popovers_quantidade[index] = new bootstrap.Popover($('[name="quantidade[' + index + ']"]'));
            if ($('[name="quantidade[' + index + ']"]').val().trim() == '' || parseInt($('[name="quantidade[' + index + ']"]').val()) == 0) {
                campos_popovers_quantidade[index].show();
                $('[name="quantidade[' + index + ']"]').trigger('focus');
                $('[name="quantidade[' + index + ']"]').on('keypress', function () { campos_popovers_quantidade[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_peso = new Array();
            campos_popovers_peso[index] = new bootstrap.Popover($('[name="peso[' + index + ']"]'));
            if ($('[name="peso[' + index + ']"]').val().trim() == '' || parseFloat($('[name="peso[' + index + ']"]').val().replace(',', '.')) === 0.00) {
                campos_popovers_peso[index].show();
                $('[name="peso[' + index + ']"]').trigger('focus');
                $('[name="peso[' + index + ']"]').on('keypress', function () { campos_popovers_peso[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_comprimento = new Array();
            campos_popovers_comprimento[index] = new bootstrap.Popover($('[name="comprimento[' + index + ']"]'));
            if ($('[name="comprimento[' + index + ']"]').val().trim() == '' || parseInt($('[name="comprimento[' + index + ']"]').val()) == 0) {
                campos_popovers_comprimento[index].show();
                $('[name="comprimento[' + index + ']"]').trigger('focus');
                $('[name="comprimento[' + index + ']"]').on('keypress', function () { campos_popovers_comprimento[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_largura = new Array();
            campos_popovers_largura[index] = new bootstrap.Popover($('[name="largura[' + index + ']"]'));
            if ($('[name="largura[' + index + ']"]').val().trim() == '' || parseInt($('[name="largura[' + index + ']"]').val()) == 0) {
                campos_popovers_largura[index].show();
                $('[name="largura[' + index + ']"]').trigger('focus');
                $('[name="largura[' + index + ']"]').on('keypress', function () { campos_popovers_largura[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_altura = new Array();
            campos_popovers_altura[index] = new bootstrap.Popover($('[name="altura[' + index + ']"]'));
            if ($('[name="altura[' + index + ']"]').val().trim() == '' || parseInt($('[name="altura[' + index + ']"]').val()) == 0) {
                campos_popovers_altura[index].show();
                $('[name="altura[' + index + ']"]').trigger('focus');
                $('[name="altura[' + index + ']"]').on('keypress', function () { campos_popovers_altura[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_natureza = new Array();
            campos_popovers_natureza[index] = new bootstrap.Popover($('[name="natureza_carga[' + index + ']"]'));
            if ($('[name="natureza_carga[' + index + ']"]').val().trim() == '') {
                campos_popovers_natureza[index].show();
                $('[name="natureza_carga[' + index + ']"]').trigger('focus');
                $('[name="natureza_carga[' + index + ']"]').on('keypress', function () { campos_popovers_natureza[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_embalamento = new Array();
            campos_popovers_embalamento[index] = new bootstrap.Popover($('[name="modo_embalamento[' + index + ']"]'));
            if ($('[name="modo_embalamento[' + index + ']"]').val().trim() == '') {
                campos_popovers_embalamento[index].show();
                $('[name="modo_embalamento[' + index + ']"]').trigger('focus');
                $('[name="modo_embalamento[' + index + ']"]').on('change', function () { campos_popovers_embalamento[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_temp_min = new Array();
            campos_popovers_temp_min[index] = new bootstrap.Popover($('[name="temperatura_min[' + index + ']"]'));
            if ($('[name="temperatura_min[' + index + ']"]').val().trim() == '' && $('[id="temperatura-controlada[' + index + ']"]').is(':checked')) {
                campos_popovers_temp_min[index].show();
                $('[name="temperatura_min[' + index + ']"]').trigger('focus');
                $('[name="temperatura_min[' + index + ']"]').on('keypress', function () { campos_popovers_temp_min[index].hide(); })
                $('[id="temperatura-controlada[' + index + ']"]').on('click', function () { campos_popovers_temp_min[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_temp_max = new Array();
            campos_popovers_temp_max[index] = new bootstrap.Popover($('[name="temperatura_max[' + index + ']"]'));
            if ($('[name="temperatura_max[' + index + ']"]').val().trim() == '' && $('[id="temperatura-controlada[' + index + ']"]').is(':checked')) {
                campos_popovers_temp_max[index].show();
                $('[name="temperatura_max[' + index + ']"]').trigger('focus');
                $('[name="temperatura_max[' + index + ']"]').on('keypress', function () { campos_popovers_temp_max[index].hide(); })
                $('[id="temperatura-controlada[' + index + ']"]').on('click', function () { campos_popovers_temp_max[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_temp_max = new Array();
            campos_popovers_temp_max[index] = new bootstrap.Popover($('[name="temperatura_max[' + index + ']"]'));
            if (parseInt($('[name="temperatura_min[' + index + ']"]').val()) >= parseInt($('[name="temperatura_max[' + index + ']"]').val()) && $('[id="temperatura-controlada[' + index + ']"]').is(':checked')) {
                campos_popovers_temp_max[index].show();
                $('[name="temperatura_max[' + index + ']"]').trigger('focus');
                $('[name="temperatura_max[' + index + ']"]').on('keypress', function () { campos_popovers_temp_max[index].hide(); })
                $('[id="temperatura-controlada[' + index + ']"]').on('click', function () { campos_popovers_temp_max[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_adr = new Array();
            campos_popovers_adr[index] = new bootstrap.Popover($('[name="classificacao_adr[' + index + ']"]'));
            if ($('[id="adr[' + index + ']"]').is(':checked')) {
                if (($('[name="ficha_seguranca[' + index + ']"]')[0].files.length === 0) && ($('[name="classificacao_adr[' + index + ']"]').val().trim() == '')) {
                    campos_popovers_adr[index].show();
                    $('[name="classificacao_adr[' + index + ']"]').trigger('focus');
                    $('[name="classificacao_adr[' + index + ']"]').on('change', function () { campos_popovers_adr[index].hide(); })
                    $('[id="classificacao_adr[' + index + ']"], [name="ficha_seguranca[' + index + ']"]').on('click', function () { campos_popovers_adr[index].hide(); })
                    valida = false;
                    return false;
                }
            }
            else {
                valida = true;
                campos_popovers_adr[index].hide();
            }
        });
        //DATA RECOLHA
        var campos_popovers_datarecolha;
        campos_popovers_datarecolha = new bootstrap.Popover($('label[for="carga-pronta"]'));
        if (valida && !$('[name="data_recolha"]').is(':checked')) {
            campos_popovers_datarecolha.show();
            $('[name="data_recolha"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha1 = new Array();
        campos_popovers_datarecolha1 = new bootstrap.Popover($('[name="datarecolha_1"]'));
        if (valida && $('[name="datarecolha_1"]').val().trim() == '' && $('[id="recolha-depois-de"]').is(':checked')) {
            campos_popovers_datarecolha1.show();
            $('[name="datarecolha_1"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('click', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha2 = new Array();
        campos_popovers_datarecolha2 = new bootstrap.Popover($('[name="datarecolha_2"]'));
        if (valida && $('[name="datarecolha_2"]').val().trim() == '' && $('[id="recolha-exatamente-em"]').is(':checked')) {
            campos_popovers_datarecolha2.show();
            $('[name="datarecolha_2"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('click', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            valida = false;
        }
        //DATA ENTREGA
        var campos_popovers_dataentrega;
        campos_popovers_dataentrega = new bootstrap.Popover($('label[for="entrega-imediata"]'));
        if (valida && !$('[name="data_entrega"]').is(':checked')) {
            campos_popovers_dataentrega.show();
            $('[name="data_entrega"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega1;
        campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        if (valida && $('[name="dataentrega_1"]').val().trim() == '' && $('[id="entrega-ate"]').is(':checked')) {
            campos_popovers_dataentrega1.show();
            $('[name="dataentrega_1"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega2;
        campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        if (valida && $('[name="dataentrega_2"]').val().trim() == '' && $('[id="entrega-exatamente-em"]').is(':checked')) {
            campos_popovers_dataentrega2.show();
            $('[name="dataentrega_2"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            valida = false;
        }
        // Compara as datas recolha e entrega
        //var campos_popovers_dataentrega1;
        //var campos_popovers_dataentrega2;
        //campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        //campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        var datarecolha = '';
        var dataentrega = '';
        if ($('[name="datarecolha_1"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_1"]').datepicker("getDate")); //yymmdd
        if ($('[name="datarecolha_2"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_2"]').datepicker("getDate")); //yymmdd
        if ($('[name="dataentrega_1"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_1"]').datepicker("getDate")); //yymmdd    
        if ($('[name="dataentrega_2"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_2"]').datepicker("getDate")); //yymmdd    
        if (datarecolha != '' && dataentrega != '') {
            if (parseInt(datarecolha) > parseInt(dataentrega)) {
                if ($('[name="dataentrega_1"]').val() != '' && $('[name="dataentrega_1"]').is(':visible')) {
                    campos_popovers_dataentrega1.show();
                    $('[name="dataentrega_1"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                }
                if ($('[name="dataentrega_2"]').val() != '' && $('[name="dataentrega_2"]').is(':visible')) {
                    campos_popovers_dataentrega2.show();
                    $('[name="dataentrega_2"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                }
                valida = false;
            }
        }
        var campos_popovers_enderecorecolha;
        campos_popovers_enderecorecolha = new bootstrap.Popover($('[name="endereco_recolha_autocomplete"]'));
        if (valida && $('span[id="endereco-recolha-text"]').text() == '') {
            campos_popovers_enderecorecolha.show();
            $('[name="endereco_recolha_autocomplete"]').trigger('focus');
            $('[name="endereco_recolha_autocomplete"]').on('keypress', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('click', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="place_id_recolha"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            valida = false;
        }
        //LOCALIZAÇÃO ENTREGA
        var campos_popovers_enderecoentrega;
        campos_popovers_enderecoentrega = new bootstrap.Popover($('[name="endereco_entrega_autocomplete"]'));
        if (valida && $('span[id="endereco-entrega-text"]').text() == '') {
            campos_popovers_enderecoentrega.show();
            $('[name="endereco_entrega_autocomplete"]').trigger('focus');
            $('[name="endereco_entrega_autocomplete"]').on('keypress', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('click', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="place_id_entrega"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            valida = false;
        }
        // ORÇAMENTO
        var campos_popovers_orcamento;
        campos_popovers_orcamento = new bootstrap.Popover($('[name="orcamento"]'));
        if (valida && ($('[name="orcamento"]').val() == '' || !isNaN($('[name="orcamento"]').val()) || parseFloat($('[name="orcamento"]').val()) == 0)) {
            campos_popovers_orcamento.show();
            $('[name="orcamento"]').trigger('focus');
            $('[name="orcamento"]').on('keypress', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('change', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('click', function () { campos_popovers_orcamento.hide(); })
            valida = false;
        }
        var campos_popovers_csiva;
        campos_popovers_csiva = new bootstrap.Popover($('[name="csiva"]'));
        if (valida && $('[name="csiva"]').val().trim() == '') {
            campos_popovers_csiva.show();
            $('[name="csiva"]').trigger('focus');
            $('[name="csiva"]').on('change', function () { campos_popovers_csiva.hide(); })
            valida = false;
        }
        // ORDEM DE CARGA
        var campos_popovers_nomecarga;
        campos_popovers_nomecarga = new bootstrap.Popover($('[name="nome_carga"]'));
        if (valida && ($('[name="nome_carga"]').val() == '' || !is_Nome($('[name="nome_carga"]').val()))) {
            campos_popovers_nomecarga.show();
            $('[name="nome_carga"]').trigger('focus');
            $('[name="nome_carga"]').on('keypress', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('change', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('click', function () { campos_popovers_nomecarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactocarga;
        campos_popovers_nomecontactocarga = new bootstrap.Popover($('[name="nome_contacto_carga"]'));
        if (valida && ($('[name="nome_contacto_carga"]').val() == '' || !is_Nome($('[name="nome_contacto_carga"]').val()))) {
            campos_popovers_nomecontactocarga.show();
            $('[name="nome_contacto_carga"]').trigger('focus');
            $('[name="nome_contacto_carga"]').on('keypress', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('change', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('click', function () { campos_popovers_nomecontactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactocarga;
        campos_popovers_contactocarga = new bootstrap.Popover($('[name="contacto_carga"]'));
        if (valida && ($('[name="contacto_carga"]').val() == '' || !is_Telefone($('[name="contacto_carga"]').val()))) {
            campos_popovers_contactocarga.show();
            $('[name="contacto_carga"]').trigger('focus');
            $('[name="contacto_carga"]').on('keypress', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('change', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('click', function () { campos_popovers_contactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradacarga;
        campos_popovers_moradacarga = new bootstrap.Popover($('[name="morada_carga"]'));
        if (valida && ($('[name="morada_carga"]').val() == '' || !is_Morada($('[name="morada_carga"]').val()))) {
            campos_popovers_moradacarga.show();
            $('[name="morada_carga"]').trigger('focus');
            $('[name="morada_carga"]').on('keypress', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('change', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('click', function () { campos_popovers_moradacarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomedescarga;
        campos_popovers_nomedescarga = new bootstrap.Popover($('[name="nome_descarga"]'));
        if (valida && ($('[name="nome_descarga"]').val() == '' || !is_Nome($('[name="nome_descarga"]').val()))) {
            campos_popovers_nomedescarga.show();
            $('[name="nome_descarga"]').trigger('focus');
            $('[name="nome_descarga"]').on('keypress', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('change', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('click', function () { campos_popovers_nomedescarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactodescarga;
        campos_popovers_nomecontactodescarga = new bootstrap.Popover($('[name="nome_contacto_descarga"]'));
        if (valida && ($('[name="nome_contacto_descarga"]').val() == '' || !is_Nome($('[name="nome_contacto_descarga"]').val()))) {
            campos_popovers_nomecontactodescarga.show();
            $('[name="nome_contacto_descarga"]').trigger('focus');
            $('[name="nome_contacto_descarga"]').on('keypress', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('change', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('click', function () { campos_popovers_nomecontactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactodescarga;
        campos_popovers_contactodescarga = new bootstrap.Popover($('[name="contacto_descarga"]'));
        if (valida && ($('[name="contacto_descarga"]').val() == '' || !is_Telefone($('[name="contacto_descarga"]').val()))) {
            campos_popovers_contactodescarga.show();
            $('[name="contacto_descarga"]').trigger('focus');
            $('[name="contacto_descarga"]').on('keypress', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('change', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('click', function () { campos_popovers_contactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradadescarga;
        campos_popovers_moradadescarga = new bootstrap.Popover($('[name="morada_descarga"]'));
        if (valida && ($('[name="morada_descarga"]').val() == '' || !is_Morada($('[name="morada_descarga"]').val()))) {
            campos_popovers_moradadescarga.show();
            $('[name="morada_descarga"]').trigger('focus');
            $('[name="morada_descarga"]').on('keypress', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('change', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('click', function () { campos_popovers_moradadescarga.hide(); })
            valida = false;
        }
        return valida;
    }

    if ($(form_obj).attr('name') == 'nova_carga_especial') {
        // iniciacoes
        /*
        Aqui neste caso as iniciações são feitas uma a auma
        var campos_form = new Array('nome_cliente[0]', 'email[0]', 'contacto[0]', 'nome_cliente[1]', 'email[1]', 'contacto[1]', 'nome_cliente[2]', 'email[2]', 'contacto[2]', 'nome_cliente[3]', 'email[3]', 'contacto[3]', 'nome_cliente[4]', 'email[4]', 'contacto[4]');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            console.log(campo);
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })*/
        // end iniciacoes


        let valida = true;

        var campos_popovers_clientes;
        campos_popovers_clientes = new bootstrap.Popover($('[name="clientes_codigos"]'));
        if (valida && ($('[name="clientes_codigos"]').val() == '')) {
            campos_popovers_clientes.show();
            $('[name="clientes_codigos"]').trigger('focus');
            $('[name="clientes_codigos"]').on('keypress', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('change', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('click', function () { campos_popovers_clientes.hide(); })
            valida = false;
            return false;
        }


        $(form_obj).find('[name^="quantidade"]').filter(':visible').each(function (index, ele) {
            index += 1;
            var campos_popovers_quantidade = new Array();
            campos_popovers_quantidade[index] = new bootstrap.Popover($('[name="quantidade[' + index + ']"]'));
            if ($('[name="quantidade[' + index + ']"]').val().trim() == '' || parseInt($('[name="quantidade[' + index + ']"]').val()) == 0) {
                campos_popovers_quantidade[index].show();
                $('[name="quantidade[' + index + ']"]').trigger('focus');
                $('[name="quantidade[' + index + ']"]').on('keypress', function () { campos_popovers_quantidade[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_peso = new Array();
            campos_popovers_peso[index] = new bootstrap.Popover($('[name="peso[' + index + ']"]'));
            if ($('[name="peso[' + index + ']"]').val().trim() == '' || parseFloat($('[name="peso[' + index + ']"]').val().replace(',', '.')) === 0.00) {
                campos_popovers_peso[index].show();
                $('[name="peso[' + index + ']"]').trigger('focus');
                $('[name="peso[' + index + ']"]').on('keypress', function () { campos_popovers_peso[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_comprimento = new Array();
            campos_popovers_comprimento[index] = new bootstrap.Popover($('[name="comprimento[' + index + ']"]'));
            if ($('[name="comprimento[' + index + ']"]').val().trim() == '' || parseInt($('[name="comprimento[' + index + ']"]').val()) == 0) {
                campos_popovers_comprimento[index].show();
                $('[name="comprimento[' + index + ']"]').trigger('focus');
                $('[name="comprimento[' + index + ']"]').on('keypress', function () { campos_popovers_comprimento[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_largura = new Array();
            campos_popovers_largura[index] = new bootstrap.Popover($('[name="largura[' + index + ']"]'));
            if ($('[name="largura[' + index + ']"]').val().trim() == '' || parseInt($('[name="largura[' + index + ']"]').val()) == 0) {
                campos_popovers_largura[index].show();
                $('[name="largura[' + index + ']"]').trigger('focus');
                $('[name="largura[' + index + ']"]').on('keypress', function () { campos_popovers_largura[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_altura = new Array();
            campos_popovers_altura[index] = new bootstrap.Popover($('[name="altura[' + index + ']"]'));
            if ($('[name="altura[' + index + ']"]').val().trim() == '' || parseInt($('[name="altura[' + index + ']"]').val()) == 0) {
                campos_popovers_altura[index].show();
                $('[name="altura[' + index + ']"]').trigger('focus');
                $('[name="altura[' + index + ']"]').on('keypress', function () { campos_popovers_altura[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_natureza = new Array();
            campos_popovers_natureza[index] = new bootstrap.Popover($('[name="natureza_carga[' + index + ']"]'));
            if ($('[name="natureza_carga[' + index + ']"]').val().trim() == '') {
                campos_popovers_natureza[index].show();
                $('[name="natureza_carga[' + index + ']"]').trigger('focus');
                $('[name="natureza_carga[' + index + ']"]').on('keypress', function () { campos_popovers_natureza[index].hide(); })
                valida = false;
                return false;
            }
            else {
                valida = true;
                campos_popovers_natureza[index].hide();
            }
        });
        //DATA RECOLHA
        var campos_popovers_datarecolha;
        campos_popovers_datarecolha = new bootstrap.Popover($('label[for="carga-pronta"]'));
        if (valida && !$('[name="data_recolha"]').is(':checked')) {
            campos_popovers_datarecolha.show();
            $('[name="data_recolha"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha1 = new Array();
        campos_popovers_datarecolha1 = new bootstrap.Popover($('[name="datarecolha_1"]'));
        if (valida && $('[name="datarecolha_1"]').val().trim() == '' && $('[id="recolha-depois-de"]').is(':checked')) {
            campos_popovers_datarecolha1.show();
            $('[name="datarecolha_1"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('click', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha2 = new Array();
        campos_popovers_datarecolha2 = new bootstrap.Popover($('[name="datarecolha_2"]'));
        if (valida && $('[name="datarecolha_2"]').val().trim() == '' && $('[id="recolha-exatamente-em"]').is(':checked')) {
            campos_popovers_datarecolha2.show();
            $('[name="datarecolha_2"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('click', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            valida = false;
        }
        //DATA ENTREGA
        var campos_popovers_dataentrega;
        campos_popovers_dataentrega = new bootstrap.Popover($('label[for="entrega-imediata"]'));
        if (valida && !$('[name="data_entrega"]').is(':checked')) {
            campos_popovers_dataentrega.show();
            $('[name="data_entrega"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega1;
        campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        if (valida && $('[name="dataentrega_1"]').val().trim() == '' && $('[id="entrega-ate"]').is(':checked')) {
            campos_popovers_dataentrega1.show();
            $('[name="dataentrega_1"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega2;
        campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        if (valida && $('[name="dataentrega_2"]').val().trim() == '' && $('[id="entrega-exatamente-em"]').is(':checked')) {
            campos_popovers_dataentrega2.show();
            $('[name="dataentrega_2"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            valida = false;
        }
        // Compara as datas recolha e entrega
        //var campos_popovers_dataentrega1;
        //var campos_popovers_dataentrega2;
        //campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        //campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        var datarecolha = '';
        var dataentrega = '';
        if ($('[name="datarecolha_1"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_1"]').datepicker("getDate")); //yymmdd
        if ($('[name="datarecolha_2"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_2"]').datepicker("getDate")); //yymmdd
        if ($('[name="dataentrega_1"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_1"]').datepicker("getDate")); //yymmdd    
        if ($('[name="dataentrega_2"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_2"]').datepicker("getDate")); //yymmdd    
        if (datarecolha != '' && dataentrega != '') {
            if (parseInt(datarecolha) > parseInt(dataentrega)) {
                if ($('[name="dataentrega_1"]').val() != '' && $('[name="dataentrega_1"]').is(':visible')) {
                    campos_popovers_dataentrega1.show();
                    $('[name="dataentrega_1"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                }
                if ($('[name="dataentrega_2"]').val() != '' && $('[name="dataentrega_2"]').is(':visible')) {
                    campos_popovers_dataentrega2.show();
                    $('[name="dataentrega_2"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                }
                valida = false;
            }
        }
        var campos_popovers_enderecorecolha;
        campos_popovers_enderecorecolha = new bootstrap.Popover($('[name="endereco_recolha_autocomplete"]'));
        if (valida && $('span[id="endereco-recolha-text"]').text() == '') {
            campos_popovers_enderecorecolha.show();
            $('[name="endereco_recolha_autocomplete"]').trigger('focus');
            $('[name="endereco_recolha_autocomplete"]').on('keypress', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('click', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="place_id_recolha"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            valida = false;
        }
        //LOCALIZAÇÃO ENTREGA
        var campos_popovers_enderecoentrega;
        campos_popovers_enderecoentrega = new bootstrap.Popover($('[name="endereco_entrega_autocomplete"]'));
        if (valida && $('span[id="endereco-entrega-text"]').text() == '') {
            campos_popovers_enderecoentrega.show();
            $('[name="endereco_entrega_autocomplete"]').trigger('focus');
            $('[name="endereco_entrega_autocomplete"]').on('keypress', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('click', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="place_id_entrega"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            valida = false;
        }
        // ORÇAMENTO
        var campos_popovers_orcamento;
        campos_popovers_orcamento = new bootstrap.Popover($('[name="orcamento"]'));
        if (valida && ($('[name="orcamento"]').val() == '' || !isNaN($('[name="orcamento"]').val()) || parseFloat($('[name="orcamento"]').val()) == 0)) {
            campos_popovers_orcamento.show();
            $('[name="orcamento"]').trigger('focus');
            $('[name="orcamento"]').on('keypress', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('change', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('click', function () { campos_popovers_orcamento.hide(); })
            valida = false;
        }
        var campos_popovers_csiva;
        campos_popovers_csiva = new bootstrap.Popover($('[name="csiva"]'));
        if (valida && $('[name="csiva"]').val().trim() == '') {
            campos_popovers_csiva.show();
            $('[name="csiva"]').trigger('focus');
            $('[name="csiva"]').on('change', function () { campos_popovers_csiva.hide(); })
            valida = false;
        }
        // ORDEM DE CARGA
        var campos_popovers_nomecarga;
        campos_popovers_nomecarga = new bootstrap.Popover($('[name="nome_carga"]'));
        if (valida && ($('[name="nome_carga"]').val() == '' || !is_Nome($('[name="nome_carga"]').val()))) {
            campos_popovers_nomecarga.show();
            $('[name="nome_carga"]').trigger('focus');
            $('[name="nome_carga"]').on('keypress', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('change', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('click', function () { campos_popovers_nomecarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactocarga;
        campos_popovers_nomecontactocarga = new bootstrap.Popover($('[name="nome_contacto_carga"]'));
        if (valida && ($('[name="nome_contacto_carga"]').val() == '' || !is_Nome($('[name="nome_contacto_carga"]').val()))) {
            campos_popovers_nomecontactocarga.show();
            $('[name="nome_contacto_carga"]').trigger('focus');
            $('[name="nome_contacto_carga"]').on('keypress', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('change', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('click', function () { campos_popovers_nomecontactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactocarga;
        campos_popovers_contactocarga = new bootstrap.Popover($('[name="contacto_carga"]'));
        if (valida && ($('[name="contacto_carga"]').val() == '' || !is_Telefone($('[name="contacto_carga"]').val()))) {
            campos_popovers_contactocarga.show();
            $('[name="contacto_carga"]').trigger('focus');
            $('[name="contacto_carga"]').on('keypress', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('change', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('click', function () { campos_popovers_contactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradacarga;
        campos_popovers_moradacarga = new bootstrap.Popover($('[name="morada_carga"]'));
        if (valida && ($('[name="morada_carga"]').val() == '' || !is_Morada($('[name="morada_carga"]').val()))) {
            campos_popovers_moradacarga.show();
            $('[name="morada_carga"]').trigger('focus');
            $('[name="morada_carga"]').on('keypress', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('change', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('click', function () { campos_popovers_moradacarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomedescarga;
        campos_popovers_nomedescarga = new bootstrap.Popover($('[name="nome_descarga"]'));
        if (valida && ($('[name="nome_descarga"]').val() == '' || !is_Nome($('[name="nome_descarga"]').val()))) {
            campos_popovers_nomedescarga.show();
            $('[name="nome_descarga"]').trigger('focus');
            $('[name="nome_descarga"]').on('keypress', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('change', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('click', function () { campos_popovers_nomedescarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactodescarga;
        campos_popovers_nomecontactodescarga = new bootstrap.Popover($('[name="nome_contacto_descarga"]'));
        if (valida && ($('[name="nome_contacto_descarga"]').val() == '' || !is_Nome($('[name="nome_contacto_descarga"]').val()))) {
            campos_popovers_nomecontactodescarga.show();
            $('[name="nome_contacto_descarga"]').trigger('focus');
            $('[name="nome_contacto_descarga"]').on('keypress', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('change', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('click', function () { campos_popovers_nomecontactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactodescarga;
        campos_popovers_contactodescarga = new bootstrap.Popover($('[name="contacto_descarga"]'));
        if (valida && ($('[name="contacto_descarga"]').val() == '' || !is_Telefone($('[name="contacto_descarga"]').val()))) {
            campos_popovers_contactodescarga.show();
            $('[name="contacto_descarga"]').trigger('focus');
            $('[name="contacto_descarga"]').on('keypress', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('change', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('click', function () { campos_popovers_contactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradadescarga;
        campos_popovers_moradadescarga = new bootstrap.Popover($('[name="morada_descarga"]'));
        if (valida && ($('[name="morada_descarga"]').val() == '' || !is_Morada($('[name="morada_descarga"]').val()))) {
            campos_popovers_moradadescarga.show();
            $('[name="morada_descarga"]').trigger('focus');
            $('[name="morada_descarga"]').on('keypress', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('change', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('click', function () { campos_popovers_moradadescarga.hide(); })
            valida = false;
        }
        return valida;
    }

    if ($(form_obj).attr('name') == 'nova_carga_veiculos') {
        // iniciacoes
        /*
        Aqui neste caso as iniciações são feitas uma a auma
        var campos_form = new Array('nome_cliente[0]', 'email[0]', 'contacto[0]', 'nome_cliente[1]', 'email[1]', 'contacto[1]', 'nome_cliente[2]', 'email[2]', 'contacto[2]', 'nome_cliente[3]', 'email[3]', 'contacto[3]', 'nome_cliente[4]', 'email[4]', 'contacto[4]');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            console.log(campo);
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })*/
        // end iniciacoes


        let valida = true;

        var campos_popovers_clientes;
        campos_popovers_clientes = new bootstrap.Popover($('[name="clientes_codigos"]'));
        if (valida && ($('[name="clientes_codigos"]').val() == '')) {
            campos_popovers_clientes.show();
            $('[name="clientes_codigos"]').trigger('focus');
            $('[name="clientes_codigos"]').on('keypress', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('change', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('click', function () { campos_popovers_clientes.hide(); })
            valida = false;
            return false;
        }

        
        $(form_obj).find('[name^="quantidade"]').filter(':visible').each(function (index, ele) {
            index += 1;
            var campos_popovers_quantidade = new Array();
            campos_popovers_quantidade[index] = new bootstrap.Popover($('[name="quantidade[' + index + ']"]'));
            if ($('[name="quantidade[' + index + ']"]').val().trim() == '' || parseInt($('[name="quantidade[' + index + ']"]').val()) == 0) {
                campos_popovers_quantidade[index].show();
                $('[name="quantidade[' + index + ']"]').trigger('focus');
                $('[name="quantidade[' + index + ']"]').on('keypress', function () { campos_popovers_quantidade[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_peso = new Array();
            campos_popovers_peso[index] = new bootstrap.Popover($('[name="peso[' + index + ']"]'));
            if ($('[name="peso[' + index + ']"]').val().trim() == '' || parseFloat($('[name="peso[' + index + ']"]').val().replace(',', '.')) === 0.00) {
                campos_popovers_peso[index].show();
                $('[name="peso[' + index + ']"]').trigger('focus');
                $('[name="peso[' + index + ']"]').on('keypress', function () { campos_popovers_peso[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_marca = new Array();
            campos_popovers_marca[index] = new bootstrap.Popover($('[name="marca[' + index + ']"]'));
            if ($('[name="marca[' + index + ']"]').val().trim() == '' || parseInt($('[name="marca[' + index + ']"]').val()) == 0) {
                campos_popovers_marca[index].show();
                $('[name="marca[' + index + ']"]').trigger('focus');
                $('[name="marca[' + index + ']"]').on('keypress', function () { campos_popovers_marca[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_modelo = new Array();
            campos_popovers_modelo[index] = new bootstrap.Popover($('[name="modelo[' + index + ']"]'));
            if ($('[name="modelo[' + index + ']"]').val().trim() == '' || parseInt($('[name="modelo[' + index + ']"]').val()) == 0) {
                campos_popovers_modelo[index].show();
                $('[name="modelo[' + index + ']"]').trigger('focus');
                $('[name="modelo[' + index + ']"]').on('keypress', function () { campos_popovers_modelo[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_tipoveiculo = new Array();
            campos_popovers_tipoveiculo[index] = new bootstrap.Popover($('[name="tipo_veiculo[' + index + ']"]'));
            if ($('[name="tipo_veiculo[' + index + ']"]').val().trim() == '') {
                campos_popovers_tipoveiculo[index].show();
                $('[name="tipo_veiculo[' + index + ']"]').trigger('focus');
                $('[name="tipo_veiculo[' + index + ']"]').on('change', function () { campos_popovers_tipoveiculo[index].hide(); })
                valida = false;
                return false;
            }
            else {
                valida = true;
                campos_popovers_tipoveiculo[index].hide();
            }
        });
        
        //DATA RECOLHA
        var campos_popovers_datarecolha;
        campos_popovers_datarecolha = new bootstrap.Popover($('label[for="carga-pronta"]'));
        if (valida && !$('[name="data_recolha"]').is(':checked')) {
            campos_popovers_datarecolha.show();
            $('[name="data_recolha"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha1 = new Array();
        campos_popovers_datarecolha1 = new bootstrap.Popover($('[name="datarecolha_1"]'));
        if (valida && $('[name="datarecolha_1"]').val().trim() == '' && $('[id="recolha-depois-de"]').is(':checked')) {
            campos_popovers_datarecolha1.show();
            $('[name="datarecolha_1"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('click', function () { campos_popovers_datarecolha1.hide(); })
            $('[name="datarecolha_1"]').on('change', function () { campos_popovers_datarecolha1.hide(); })
            valida = false;
        }
        var campos_popovers_datarecolha2 = new Array();
        campos_popovers_datarecolha2 = new bootstrap.Popover($('[name="datarecolha_2"]'));
        if (valida && $('[name="datarecolha_2"]').val().trim() == '' && $('[id="recolha-exatamente-em"]').is(':checked')) {
            campos_popovers_datarecolha2.show();
            $('[name="datarecolha_2"]').trigger('focus');
            $('[name="data_recolha"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('click', function () { campos_popovers_datarecolha2.hide(); })
            $('[name="datarecolha_2"]').on('change', function () { campos_popovers_datarecolha2.hide(); })
            valida = false;
        }
        //DATA ENTREGA
        var campos_popovers_dataentrega;
        campos_popovers_dataentrega = new bootstrap.Popover($('label[for="entrega-imediata"]'));
        if (valida && !$('[name="data_entrega"]').is(':checked')) {
            campos_popovers_dataentrega.show();
            $('[name="data_entrega"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega1;
        campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        if (valida && $('[name="dataentrega_1"]').val().trim() == '' && $('[id="entrega-ate"]').is(':checked')) {
            campos_popovers_dataentrega1.show();
            $('[name="dataentrega_1"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
            $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
            valida = false;
        }
        var campos_popovers_dataentrega2;
        campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        if (valida && $('[name="dataentrega_2"]').val().trim() == '' && $('[id="entrega-exatamente-em"]').is(':checked')) {
            campos_popovers_dataentrega2.show();
            $('[name="dataentrega_2"]').trigger('focus');
            $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
            $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
            valida = false;
        }
        // Compara as datas recolha e entrega
        //var campos_popovers_dataentrega1;
        //var campos_popovers_dataentrega2;
        //campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        //campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        var datarecolha = '';
        var dataentrega = '';
        if ($('[name="datarecolha_1"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_1"]').datepicker("getDate")); //yymmdd
        if ($('[name="datarecolha_2"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha_2"]').datepicker("getDate")); //yymmdd
        if ($('[name="dataentrega_1"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_1"]').datepicker("getDate")); //yymmdd    
        if ($('[name="dataentrega_2"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega_2"]').datepicker("getDate")); //yymmdd    
        if (datarecolha != '' && dataentrega != '') {
            if (parseInt(datarecolha) > parseInt(dataentrega)) {
                if ($('[name="dataentrega_1"]').val() != '' && $('[name="dataentrega_1"]').is(':visible')) {
                    campos_popovers_dataentrega1.show();
                    $('[name="dataentrega_1"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('click', function () { campos_popovers_dataentrega1.hide(); })
                    $('[name="dataentrega_1"]').on('change', function () { campos_popovers_dataentrega1.hide(); })
                }
                if ($('[name="dataentrega_2"]').val() != '' && $('[name="dataentrega_2"]').is(':visible')) {
                    campos_popovers_dataentrega2.show();
                    $('[name="dataentrega_2"]').trigger('focus');
                    $('[name="data_entrega"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('click', function () { campos_popovers_dataentrega2.hide(); })
                    $('[name="dataentrega_2"]').on('change', function () { campos_popovers_dataentrega2.hide(); })
                }
                valida = false;
            }
        }
        var campos_popovers_enderecorecolha;
        campos_popovers_enderecorecolha = new bootstrap.Popover($('[name="endereco_recolha_autocomplete"]'));
        if (valida && $('span[id="endereco-recolha-text"]').text() == '') {
            campos_popovers_enderecorecolha.show();
            $('[name="endereco_recolha_autocomplete"]').trigger('focus');
            $('[name="endereco_recolha_autocomplete"]').on('keypress', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('click', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="place_id_recolha"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            valida = false;
        }
        //LOCALIZAÇÃO ENTREGA
        var campos_popovers_enderecoentrega;
        campos_popovers_enderecoentrega = new bootstrap.Popover($('[name="endereco_entrega_autocomplete"]'));
        if (valida && $('span[id="endereco-entrega-text"]').text() == '') {
            campos_popovers_enderecoentrega.show();
            $('[name="endereco_entrega_autocomplete"]').trigger('focus');
            $('[name="endereco_entrega_autocomplete"]').on('keypress', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('click', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="place_id_entrega"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            valida = false;
        }
        // ORÇAMENTO
        var campos_popovers_orcamento;
        campos_popovers_orcamento = new bootstrap.Popover($('[name="orcamento"]'));
        if (valida && ($('[name="orcamento"]').val() == '' || !isNaN($('[name="orcamento"]').val()) || parseFloat($('[name="orcamento"]').val()) == 0)) {
            campos_popovers_orcamento.show();
            $('[name="orcamento"]').trigger('focus');
            $('[name="orcamento"]').on('keypress', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('change', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('click', function () { campos_popovers_orcamento.hide(); })
            valida = false;
        }
        var campos_popovers_csiva;
        campos_popovers_csiva = new bootstrap.Popover($('[name="csiva"]'));
        if (valida && $('[name="csiva"]').val().trim() == '') {
            campos_popovers_csiva.show();
            $('[name="csiva"]').trigger('focus');
            $('[name="csiva"]').on('change', function () { campos_popovers_csiva.hide(); })
            valida = false;
        }
        // ORDEM DE CARGA
        var campos_popovers_nomecarga;
        campos_popovers_nomecarga = new bootstrap.Popover($('[name="nome_carga"]'));
        if (valida && ($('[name="nome_carga"]').val() == '' || !is_Nome($('[name="nome_carga"]').val()))) {
            campos_popovers_nomecarga.show();
            $('[name="nome_carga"]').trigger('focus');
            $('[name="nome_carga"]').on('keypress', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('change', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('click', function () { campos_popovers_nomecarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactocarga;
        campos_popovers_nomecontactocarga = new bootstrap.Popover($('[name="nome_contacto_carga"]'));
        if (valida && ($('[name="nome_contacto_carga"]').val() == '' || !is_Nome($('[name="nome_contacto_carga"]').val()))) {
            campos_popovers_nomecontactocarga.show();
            $('[name="nome_contacto_carga"]').trigger('focus');
            $('[name="nome_contacto_carga"]').on('keypress', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('change', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('click', function () { campos_popovers_nomecontactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactocarga;
        campos_popovers_contactocarga = new bootstrap.Popover($('[name="contacto_carga"]'));
        if (valida && ($('[name="contacto_carga"]').val() == '' || !is_Telefone($('[name="contacto_carga"]').val()))) {
            campos_popovers_contactocarga.show();
            $('[name="contacto_carga"]').trigger('focus');
            $('[name="contacto_carga"]').on('keypress', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('change', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('click', function () { campos_popovers_contactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradacarga;
        campos_popovers_moradacarga = new bootstrap.Popover($('[name="morada_carga"]'));
        if (valida && ($('[name="morada_carga"]').val() == '' || !is_Morada($('[name="morada_carga"]').val()))) {
            campos_popovers_moradacarga.show();
            $('[name="morada_carga"]').trigger('focus');
            $('[name="morada_carga"]').on('keypress', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('change', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('click', function () { campos_popovers_moradacarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomedescarga;
        campos_popovers_nomedescarga = new bootstrap.Popover($('[name="nome_descarga"]'));
        if (valida && ($('[name="nome_descarga"]').val() == '' || !is_Nome($('[name="nome_descarga"]').val()))) {
            campos_popovers_nomedescarga.show();
            $('[name="nome_descarga"]').trigger('focus');
            $('[name="nome_descarga"]').on('keypress', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('change', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('click', function () { campos_popovers_nomedescarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactodescarga;
        campos_popovers_nomecontactodescarga = new bootstrap.Popover($('[name="nome_contacto_descarga"]'));
        if (valida && ($('[name="nome_contacto_descarga"]').val() == '' || !is_Nome($('[name="nome_contacto_descarga"]').val()))) {
            campos_popovers_nomecontactodescarga.show();
            $('[name="nome_contacto_descarga"]').trigger('focus');
            $('[name="nome_contacto_descarga"]').on('keypress', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('change', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('click', function () { campos_popovers_nomecontactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactodescarga;
        campos_popovers_contactodescarga = new bootstrap.Popover($('[name="contacto_descarga"]'));
        if (valida && ($('[name="contacto_descarga"]').val() == '' || !is_Telefone($('[name="contacto_descarga"]').val()))) {
            campos_popovers_contactodescarga.show();
            $('[name="contacto_descarga"]').trigger('focus');
            $('[name="contacto_descarga"]').on('keypress', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('change', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('click', function () { campos_popovers_contactodescarga.hide(); })
            valida = false;
        } 
        var campos_popovers_moradadescarga;
        campos_popovers_moradadescarga = new bootstrap.Popover($('[name="morada_descarga"]'));
        if (valida && ($('[name="morada_descarga"]').val() == '' || !is_Morada($('[name="morada_descarga"]').val()))) {
            campos_popovers_moradadescarga.show();
            $('[name="morada_descarga"]').trigger('focus');
            $('[name="morada_descarga"]').on('keypress', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('change', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('click', function () { campos_popovers_moradadescarga.hide(); })
            valida = false;
        }
        return valida;
    }
    
    if ($(form_obj).attr('name') == 'nova_carga_documentacao') {
        // iniciacoes
        /*
        Aqui neste caso as iniciações são feitas uma a auma
        var campos_form = new Array('nome_cliente[0]', 'email[0]', 'contacto[0]', 'nome_cliente[1]', 'email[1]', 'contacto[1]', 'nome_cliente[2]', 'email[2]', 'contacto[2]', 'nome_cliente[3]', 'email[3]', 'contacto[3]', 'nome_cliente[4]', 'email[4]', 'contacto[4]');
        var campos_obj = new Array();
        var campos_popovers = new Array();
        $(campos_form).each(function (index, campo) {
            console.log(campo);
            campos_obj[index] = $(form_obj).find('[name="' + campo + '"]');
            campos_popovers[index] = new bootstrap.Popover(campos_obj[index]);
        })*/
        // end iniciacoes


        let valida = true;

        var campos_popovers_clientes;
        campos_popovers_clientes = new bootstrap.Popover($('[name="clientes_codigos"]'));
        if (valida && ($('[name="clientes_codigos"]').val() == '')) {
            campos_popovers_clientes.show();
            $('[name="clientes_codigos"]').trigger('focus');
            $('[name="clientes_codigos"]').on('keypress', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('change', function () { campos_popovers_clientes.hide(); })
            $('[name="clientes_codigos"]').on('click', function () { campos_popovers_clientes.hide(); })
            valida = false;
            return false;
        }


        $(form_obj).find('[name^="quantidade"]').filter(':visible').each(function (index, ele) {
            index += 1;
            var campos_popovers_quantidade = new Array();
            campos_popovers_quantidade[index] = new bootstrap.Popover($('[name="quantidade[' + index + ']"]'));
            if ($('[name="quantidade[' + index + ']"]').val().trim() == '' || parseInt($('[name="quantidade[' + index + ']"]').val()) == 0) {
                campos_popovers_quantidade[index].show();
                $('[name="quantidade[' + index + ']"]').trigger('focus');
                $('[name="quantidade[' + index + ']"]').on('keypress', function () { campos_popovers_quantidade[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_peso = new Array();
            campos_popovers_peso[index] = new bootstrap.Popover($('[name="peso[' + index + ']"]'));
            if ($('[name="peso[' + index + ']"]').val().trim() == '' || parseFloat($('[name="peso[' + index + ']"]').val().replace(',', '.')) === 0.00) {
                campos_popovers_peso[index].show();
                $('[name="peso[' + index + ']"]').trigger('focus');
                $('[name="peso[' + index + ']"]').on('keypress', function () { campos_popovers_peso[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_comprimento = new Array();
            campos_popovers_comprimento[index] = new bootstrap.Popover($('[name="comprimento[' + index + ']"]'));
            if ($('[name="comprimento[' + index + ']"]').val().trim() == '' || parseInt($('[name="comprimento[' + index + ']"]').val()) == 0) {
                campos_popovers_comprimento[index].show();
                $('[name="comprimento[' + index + ']"]').trigger('focus');
                $('[name="comprimento[' + index + ']"]').on('keypress', function () { campos_popovers_comprimento[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_largura = new Array();
            campos_popovers_largura[index] = new bootstrap.Popover($('[name="largura[' + index + ']"]'));
            if ($('[name="largura[' + index + ']"]').val().trim() == '' || parseInt($('[name="largura[' + index + ']"]').val()) == 0) {
                campos_popovers_largura[index].show();
                $('[name="largura[' + index + ']"]').trigger('focus');
                $('[name="largura[' + index + ']"]').on('keypress', function () { campos_popovers_largura[index].hide(); })
                valida = false;
                return false;
            }
            var campos_popovers_altura = new Array();
            campos_popovers_altura[index] = new bootstrap.Popover($('[name="altura[' + index + ']"]'));
            if ($('[name="altura[' + index + ']"]').val().trim() == '' || parseInt($('[name="altura[' + index + ']"]').val()) == 0) {
                campos_popovers_altura[index].show();
                $('[name="altura[' + index + ']"]').trigger('focus');
                $('[name="altura[' + index + ']"]').on('keypress', function () { campos_popovers_altura[index].hide(); })
                valida = false;
                return false;
            }
            else {
                valida = true;
                campos_popovers_altura[index].hide();
            }
        });


        //DATA RECOLHA
        var campos_popovers_datarecolha;
        campos_popovers_datarecolha = new bootstrap.Popover($('[name="datarecolha"]'));
        if (valida && $('[name="datarecolha"]').val().trim() == '') {
            campos_popovers_datarecolha.show();
            $('[name="datarecolha"]').trigger('focus');
            $('[name="datarecolha"]').on('click', function () { campos_popovers_datarecolha.hide(); })
            $('[name="datarecolha"]').on('change', function () { campos_popovers_datarecolha.hide(); })
            valida = false;
        }
        //DATA ENTREGA
        var campos_popovers_dataentrega;
        campos_popovers_dataentrega = new bootstrap.Popover($('[name="dataentrega"]'));
        if (valida && $('[name="dataentrega"]').val().trim() == '') {
            campos_popovers_dataentrega.show();
            $('[name="dataentrega"]').trigger('focus');
            $('[name="dataentrega"]').on('click', function () { campos_popovers_dataentrega.hide(); })
            $('[name="dataentrega"]').on('change', function () { campos_popovers_dataentrega.hide(); })
            valida = false;
        }
        // Compara as datas recolha e entrega
        //var campos_popovers_dataentrega1;
        //var campos_popovers_dataentrega2;
        //campos_popovers_dataentrega1 = new bootstrap.Popover($('[name="dataentrega_1"]'));
        //campos_popovers_dataentrega2 = new bootstrap.Popover($('[name="dataentrega_2"]'));
        var datarecolha = '';
        var dataentrega = '';
        if ($('[name="datarecolha"]').val() != '')
            var datarecolha = $.datepicker.formatDate('yymmdd', $('[name="datarecolha"]').datepicker("getDate")); //yymmdd
        if ($('[name="dataentrega"]').val() != '')
            var dataentrega = $.datepicker.formatDate('yymmdd', $('[name="dataentrega"]').datepicker("getDate")); //yymmdd    
        if (valida && datarecolha != '' && dataentrega != '') {
            if (parseInt(datarecolha) > parseInt(dataentrega)) {
                campos_popovers_dataentrega.show();
                $('[name="dataentrega"]').trigger('focus');
                $('[name="dataentrega"]').on('click', function () { campos_popovers_dataentrega.hide(); })
                $('[name="dataentrega"]').on('change', function () { campos_popovers_dataentrega.hide(); })
                valida = false;
            }
        }

        var campos_popovers_enderecorecolha;
        campos_popovers_enderecorecolha = new bootstrap.Popover($('[name="endereco_recolha_autocomplete"]'));
        if (valida && $('span[id="endereco-recolha-text"]').text() == '') {
            campos_popovers_enderecorecolha.show();
            $('[name="endereco_recolha_autocomplete"]').trigger('focus');
            $('[name="endereco_recolha_autocomplete"]').on('keypress', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="endereco_recolha_autocomplete"]').on('click', function () { campos_popovers_enderecorecolha.hide(); })
            $('[name="place_id_recolha"]').on('change', function () { campos_popovers_enderecorecolha.hide(); })
            valida = false;
        }
        //LOCALIZAÇÃO ENTREGA
        var campos_popovers_enderecoentrega;
        campos_popovers_enderecoentrega = new bootstrap.Popover($('[name="endereco_entrega_autocomplete"]'));
        if (valida && $('span[id="endereco-entrega-text"]').text() == '') {
            campos_popovers_enderecoentrega.show();
            $('[name="endereco_entrega_autocomplete"]').trigger('focus');
            $('[name="endereco_entrega_autocomplete"]').on('keypress', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="endereco_entrega_autocomplete"]').on('click', function () { campos_popovers_enderecoentrega.hide(); })
            $('[name="place_id_entrega"]').on('change', function () { campos_popovers_enderecoentrega.hide(); })
            valida = false;
        }
        // ORÇAMENTO
        var campos_popovers_orcamento;
        campos_popovers_orcamento = new bootstrap.Popover($('[name="orcamento"]'));
        if (valida && ($('[name="orcamento"]').val() == '' || !isNaN($('[name="orcamento"]').val()) || parseFloat($('[name="orcamento"]').val()) == 0)) {
            campos_popovers_orcamento.show();
            $('[name="orcamento"]').trigger('focus');
            $('[name="orcamento"]').on('keypress', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('change', function () { campos_popovers_orcamento.hide(); })
            $('[name="orcamento"]').on('click', function () { campos_popovers_orcamento.hide(); })
            valida = false;
        }
        var campos_popovers_csiva;
        campos_popovers_csiva = new bootstrap.Popover($('[name="csiva"]'));
        if (valida && $('[name="csiva"]').val().trim() == '') {
            campos_popovers_csiva.show();
            $('[name="csiva"]').trigger('focus');
            $('[name="csiva"]').on('change', function () { campos_popovers_csiva.hide(); })
            valida = false;
        }
        // ORDEM DE CARGA
        var campos_popovers_nomecarga;
        campos_popovers_nomecarga = new bootstrap.Popover($('[name="nome_carga"]'));
        if (valida && ($('[name="nome_carga"]').val() == '' || !is_Nome($('[name="nome_carga"]').val()))) {
            campos_popovers_nomecarga.show();
            $('[name="nome_carga"]').trigger('focus');
            $('[name="nome_carga"]').on('keypress', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('change', function () { campos_popovers_nomecarga.hide(); })
            $('[name="nome_carga"]').on('click', function () { campos_popovers_nomecarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactocarga;
        campos_popovers_nomecontactocarga = new bootstrap.Popover($('[name="nome_contacto_carga"]'));
        if (valida && ($('[name="nome_contacto_carga"]').val() == '' || !is_Nome($('[name="nome_contacto_carga"]').val()))) {
            campos_popovers_nomecontactocarga.show();
            $('[name="nome_contacto_carga"]').trigger('focus');
            $('[name="nome_contacto_carga"]').on('keypress', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('change', function () { campos_popovers_nomecontactocarga.hide(); })
            $('[name="nome_contacto_carga"]').on('click', function () { campos_popovers_nomecontactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactocarga;
        campos_popovers_contactocarga = new bootstrap.Popover($('[name="contacto_carga"]'));
        if (valida && ($('[name="contacto_carga"]').val() == '' || !is_Telefone($('[name="contacto_carga"]').val()))) {
            campos_popovers_contactocarga.show();
            $('[name="contacto_carga"]').trigger('focus');
            $('[name="contacto_carga"]').on('keypress', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('change', function () { campos_popovers_contactocarga.hide(); })
            $('[name="contacto_carga"]').on('click', function () { campos_popovers_contactocarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradacarga;
        campos_popovers_moradacarga = new bootstrap.Popover($('[name="morada_carga"]'));
        if (valida && ($('[name="morada_carga"]').val() == '' || !is_Morada($('[name="morada_carga"]').val()))) {
            campos_popovers_moradacarga.show();
            $('[name="morada_carga"]').trigger('focus');
            $('[name="morada_carga"]').on('keypress', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('change', function () { campos_popovers_moradacarga.hide(); })
            $('[name="morada_carga"]').on('click', function () { campos_popovers_moradacarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomedescarga;
        campos_popovers_nomedescarga = new bootstrap.Popover($('[name="nome_descarga"]'));
        if (valida && ($('[name="nome_descarga"]').val() == '' || !is_Nome($('[name="nome_descarga"]').val()))) {
            campos_popovers_nomedescarga.show();
            $('[name="nome_descarga"]').trigger('focus');
            $('[name="nome_descarga"]').on('keypress', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('change', function () { campos_popovers_nomedescarga.hide(); })
            $('[name="nome_descarga"]').on('click', function () { campos_popovers_nomedescarga.hide(); })
            valida = false;
        }
        var campos_popovers_nomecontactodescarga;
        campos_popovers_nomecontactodescarga = new bootstrap.Popover($('[name="nome_contacto_descarga"]'));
        if (valida && ($('[name="nome_contacto_descarga"]').val() == '' || !is_Nome($('[name="nome_contacto_descarga"]').val()))) {
            campos_popovers_nomecontactodescarga.show();
            $('[name="nome_contacto_descarga"]').trigger('focus');
            $('[name="nome_contacto_descarga"]').on('keypress', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('change', function () { campos_popovers_nomecontactodescarga.hide(); })
            $('[name="nome_contacto_descarga"]').on('click', function () { campos_popovers_nomecontactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_contactodescarga;
        campos_popovers_contactodescarga = new bootstrap.Popover($('[name="contacto_descarga"]'));
        if (valida && ($('[name="contacto_descarga"]').val() == '' || !is_Telefone($('[name="contacto_descarga"]').val()))) {
            campos_popovers_contactodescarga.show();
            $('[name="contacto_descarga"]').trigger('focus');
            $('[name="contacto_descarga"]').on('keypress', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('change', function () { campos_popovers_contactodescarga.hide(); })
            $('[name="contacto_descarga"]').on('click', function () { campos_popovers_contactodescarga.hide(); })
            valida = false;
        }
        var campos_popovers_moradadescarga;
        campos_popovers_moradadescarga = new bootstrap.Popover($('[name="morada_descarga"]'));
        if (valida && ($('[name="morada_descarga"]').val() == '' || !is_Morada($('[name="morada_descarga"]').val()))) {
            campos_popovers_moradadescarga.show();
            $('[name="morada_descarga"]').trigger('focus');
            $('[name="morada_descarga"]').on('keypress', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('change', function () { campos_popovers_moradadescarga.hide(); })
            $('[name="morada_descarga"]').on('click', function () { campos_popovers_moradadescarga.hide(); })
            valida = false;
        }
        return valida;
    }
    else
        return true;
}

export default valida_forms;